var galleryTop;
var galleryThumbs;
var galleryTopIndex;
var cartItemCount;
var bindclickEvent = true;
$(document).ready(function(){
    
  if($(window).width() > 1024) { 
    $('.mobileSwiper').remove();
    galleryThumbs = new Swiper('.ps__img-slider', {
      slidesPerView: 'auto',
      freeMode: true,
      allowTouchMove: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    galleryTop = new Swiper('.ps__text-slider', {
      slidesPerView: 'auto',
      allowTouchMove: false,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  	$('.sliderProductTitles li a').off('click').on('click', sliderProductTitlesChange )
    $('.swiper-button-next, .swiper-button-prev').on('click', desktopSliderClick);
  }else{
    $('.desktopSwiper').remove();
     galleryTop = new Swiper('.ps__text-slider', {
      slidesPerView: 'auto',
     loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    setPhotoInit();
    $('.bottomImg').off('click').on('click', mobilePhotoSliderChange);
    $('.swiper-button-next, .swiper-button-prev').on('click', setPhotoInit);
  }
  addProductToAjaxCart()
  $('.cart__btn').on('click',function(){
  	updateCartNote()
  })
  $.getJSON( theme.routes.shop_url + '/cart.js', function (cart, textStatus) {
   	cartItemCount = (cart.item_count);
    bindclickEvent = false;
    if(cartItemCount == 0){
      	bindclickEvent = true;
      	$('#CartContainer').empty();
     	var cartDesign = `<form action=/cart class="ajaxcart cart"data-cart-form=""method=post novalidate><div class=ajaxcart__inner><div class=ajaxcart__product><div class=ajaxcart__row data-line=1><div class=ajaxcart__product__image><a class="lazyloaded ajaxcart__product__image-bg"href="/products/%D7%9E%D7%A9%D7%A7%D7%95%D7%9C%D7%95%D7%AA-%D7%99%D7%93-%D7%9E%D7%A9%D7%95%D7%A9%D7%94-5-30-%D7%A7%D7%92?variant=42351655125232"data-bgset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"data-parent-fit=contain style="background-image:url(https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473)"><picture style=display:none><source data-srcset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"sizes=56px srcset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"><img alt=""class="lazyloaded lazyautosizes ls-is-cached"data-sizes=auto sizes=56px></picture></a></div><div class=ajaxcart__product__info><p><a class=ajaxcart__product__title href="/products/%D7%9E%D7%A9%D7%A7%D7%95%D7%9C%D7%95%D7%AA-%D7%99%D7%93-%D7%9E%D7%A9%D7%95%D7%A9%D7%94-5-30-%D7%A7%D7%92?variant=42351655125232">משקולות יד - משקולת דאמבל משושה</a> <span class=ajaxcart__product__meta>5 ק"ג</span> <span class=ajaxcart__product__price>194.70 ₪</span><div class=ajax__row><div class=ajax__qty___wrapper><div class="js-qty qty"><button class="icon-fallback-text js-qty__adjust qty__adjust js-qty__adjust--minus qty__adjust--minus"type=button data-line=1 data-id=42351655125232 data-qty=4><svg aria-hidden=true class="icon icon-minus"focusable=false role=presentation viewBox="0 0 14 14"><path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z"></path></svg> <span class=fallback-text>−</span></button> <input aria-label=quantity class="js-qty__input qty__input"data-id=42351655125232 data-line=1 min=0 name=updates[] pattern=[0-9]* type=number value=3> <button class="icon-fallback-text js-qty__adjust qty__adjust js-qty__adjust--plus qty__adjust--plus"type=button data-line=1 data-id=42351655125232 data-qty=3><svg aria-hidden=true class="icon icon-plus"focusable=false role=presentation viewBox="0 0 14 14"><path d="M7 0a.75.75 0 01.75.75v12.5a.75.75 0 11-1.5 0V.75A.75.75 0 017 0z"></path><path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z"></path></svg> <span class=fallback-text>+</span></button></div></div><div class=ajax__remove><button class=ajaxcart__product__remove type=button data-line=1 data-product-remove="">הסר</button></div></div></div></div></div><div><textarea class=input--full id=CartSpecialInstructions name=note placeholder="הערות מיוחדות לחנות"rows=4></textarea></div></div><div class=ajaxcart__footer><div class=ajaxcart__footer-row><h4 class="price price--label">סך הכל</h4><div class="price price--amount text-right"><h4 class=price>194.70 ₪</h4></div></div><small class=light-gray>משלוח חינם בקנייה מעל 80 ש"ח</small><div class=cart__row--buttons><div class=cart__buttons data-cart-buttons=""><fieldset class=cart__buttons__fieldset data-cart-buttons-fieldset=""><a class="btn btn--full drawer__button cart__btn"href=/cart>צפה בעגלה</a> <button class="btn btn--full drawer__button btn--secondary cart__checkout"type=submit name=checkout>המשך לתשלום</button></fieldset></div></div></div></form>` 
        var cartEmptyDesign = '<p class="cartEmpty">' + theme.strings.cart_empty + '</p>';
      	if($('.cartEmpty').length > 0) cartEmptyDesign = "";
        $('#CartContainer').append(cartDesign + cartEmptyDesign);
      	$('.ajaxcart').hide();
    }else{
     	$('.cartEmpty').hide(); 
    }
    if(cart.note) $('#CartSpecialInstructions').val(cart.note);
  });
  addQuantityUpdate();
  $('.variant-field').on('click', function() {
    setTimeout(function(){
    	setSelectedVariantLabel()
    },100)
  });
  setSelectedVariantLabel();
});


function addProductToAjaxCart(){
 
  $('.productSlidersHome form, .atc__quick form, .product-grid-item form')
  .off('submit')
  .on('submit', function (event) {
    event.preventDefault();

    let $form = $(this);
    let $wrapper = $form.closest('.productSlidersHome, .atc__quick, .product-grid-item');
    let $btn = $wrapper.find('.slide_btn');

    $btn.prop('disabled', true);

    let formData = $form.serialize();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function (data) {
        $btn.prop('disabled', false);
        // fetchCart();
        ajaxCart.load();
        console.log('Added to cart:', data);
      },
      error: function (xhr, status, error) {
        $btn.prop('disabled', false);
        console.error('Error adding to cart:', error);
      }
    });
  });

  
}

function setSelectedVariantLabel() {
 	var getSelectedVariant = $('.product-single__variants').val();
    var getVariantTitle = $('[value = "'+getSelectedVariant+'"]').attr('data-variant-title');
    if(getVariantTitle && getVariantTitle.toString().indexOf('/') > 0) {
      getVariantTitle = getVariantTitle.split('/');
      $.each(getVariantTitle,function(i,v){
          $('.variant-label .variant-show').eq(i).html(getVariantTitle[i]); 
      });
      var getVariantValues = JSON.parse($('.productVariantJson').val());
      var optionOneArr = [];
      for(var j = 0; j < getVariantValues.length; j++) {
        if(getVariantValues[j].available) {
          if($.inArray(getVariantValues[j].option1, optionOneArr) === -1) optionOneArr.push((getVariantValues[j].option1))
        }
      }
      $('.option-variant-1').addClass('outOfStock')
      for(var k = 0; k < optionOneArr.length; k++) {
        var splitedValue = optionOneArr[k].split('"').join('');
        $('[data-option-value="'+splitedValue+'"]').removeClass('outOfStock');
      }
      $('[data-option="option2"] .variant-field').addClass('outOfStock');
      for(var i = 0; i < getVariantValues.length; i++) {
        var getfirstString = (getVariantTitle[0].replace(/ /g,''));
        var getSecondString = ((getVariantValues[i].option1).replace(/ /g,''));
        if(getfirstString == getSecondString && getVariantValues[i].available) {
          $('[value = "'+getVariantValues[i].option2+'"]').parent().removeClass('outOfStock')
        }
      }
    }else{
      var getVariantValues = JSON.parse($('.productVariantJson').val());
      var optionOneArr = [];
      for(var j = 0; j < getVariantValues.length; j++) {
        if(getVariantValues[j].available) {
          if($.inArray(getVariantValues[j].option1, optionOneArr) === -1) optionOneArr.push((getVariantValues[j].option1))
        }
      }
      $('.option-variant-1').addClass('outOfStock')
      for(var k = 0; k < optionOneArr.length; k++) {
        var splitedValue = optionOneArr[k].split('"').join('');
        $('[data-option-value="'+splitedValue+'"]').removeClass('outOfStock');
      }
      $('.variant-label .variant-show').html(getVariantTitle); 
    }
    
}

function addQuantityUpdate() {
 
  $('.js-qty__adjust').on('click', function() {
  	var $el = $(this);
    var line = $el.data('line');
    var $qtySelector = $el.siblings('.js-qty__input');
    var qty = parseInt($qtySelector.val().replace(/\D/g, ''));

    var qty = validateQty(qty);

    // Add or subtract from the current quantity
    if ($el.hasClass('js-qty__adjust--plus')) {
      qty++;
    } else {
      qty--;
      if (qty <= 0) qty = 0;
    }

    // If it has a data-line, update the cart.
    // Otherwise, just update the input's number
    if (line) {
      $('.ajaxcart').addClass('is-loading');
      $.ajax({
          url:'cart/change.js',
          data:{
          'line': line,
          'quantity': qty
     	  },
          dataType:'json',
          type:'post',
          contentType: 'application/x-www-form-urlencoded',
          success:function(response){
             $('.ajaxcart').removeClass('is-loading');
       		 fetchCart();    
          },
          error : function() {
            $('.ajaxcart').removeClass('is-loading');
          }
      });      
    }
  });
  
}

function validateQty(qty) {
  if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

function setPhotoInit() {
  galleryTopIndex = galleryTop.activeIndex % $('.bottomImg').length;
  $('.topImg').hide();
  $("#topImg_"+galleryTopIndex).show();
  $('.bottomImg').show();
  $("#bottomImg_"+galleryTopIndex).hide(); 
}

function mobilePhotoSliderChange() {
  var getIndex = ($(this).attr('id').split('_')[1]) % $('.bottomImg').length;
  galleryTop.slideTo(getIndex);
  setPhotoInit();
}

function sliderProductTitlesChange(event) {
  event.preventDefault();
  var getProductTitleIndex = $(this).closest('li').index();
  $(this).closest('ul').children('li').removeClass('active');
  $(this).closest('li').addClass('active')
  galleryTop.slideTo(getProductTitleIndex);
}

function fetchCart() {
  jQuery.getJSON( theme.routes.shop_url + '/cart.js', function (cart, textStatus) {
    var cartItemCount = (cart.item_count);
    if(cartItemCount == 0){
      	$('#CartContainer').empty();
     	var cartDesign = `<form action=/cart class="ajaxcart cart"data-cart-form=""method=post novalidate><div class=ajaxcart__inner><div class=ajaxcart__product><div class=ajaxcart__row data-line=1><div class=ajaxcart__product__image><a class="lazyloaded ajaxcart__product__image-bg"href="/products/%D7%9E%D7%A9%D7%A7%D7%95%D7%9C%D7%95%D7%AA-%D7%99%D7%93-%D7%9E%D7%A9%D7%95%D7%A9%D7%94-5-30-%D7%A7%D7%92?variant=42351655125232"data-bgset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"data-parent-fit=contain style="background-image:url(https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473)"><picture style=display:none><source data-srcset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"sizes=56px srcset="https://cdn.shopify.com/s/files/1/0288/8482/8291/products/5kg_ready_120x120.jpg?v=1647197473"><img alt=""class="lazyloaded lazyautosizes ls-is-cached"data-sizes=auto sizes=56px></picture></a></div><div class=ajaxcart__product__info><p><a class=ajaxcart__product__title href="/products/%D7%9E%D7%A9%D7%A7%D7%95%D7%9C%D7%95%D7%AA-%D7%99%D7%93-%D7%9E%D7%A9%D7%95%D7%A9%D7%94-5-30-%D7%A7%D7%92?variant=42351655125232">משקולות יד - משקולת דאמבל משושה</a> <span class=ajaxcart__product__meta>5 ק"ג</span> <span class=ajaxcart__product__price>194.70 ₪</span><div class=ajax__row><div class=ajax__qty___wrapper><div class="js-qty qty"><button class="icon-fallback-text js-qty__adjust qty__adjust js-qty__adjust--minus qty__adjust--minus"type=button data-line=1 data-id=42351655125232 data-qty=4><svg aria-hidden=true class="icon icon-minus"focusable=false role=presentation viewBox="0 0 14 14"><path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z"></path></svg> <span class=fallback-text>−</span></button> <input aria-label=quantity class="js-qty__input qty__input"data-id=42351655125232 data-line=1 min=0 name=updates[] pattern=[0-9]* type=number value=3> <button class="icon-fallback-text js-qty__adjust qty__adjust js-qty__adjust--plus qty__adjust--plus"type=button data-line=1 data-id=42351655125232 data-qty=3><svg aria-hidden=true class="icon icon-plus"focusable=false role=presentation viewBox="0 0 14 14"><path d="M7 0a.75.75 0 01.75.75v12.5a.75.75 0 11-1.5 0V.75A.75.75 0 017 0z"></path><path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z"></path></svg> <span class=fallback-text>+</span></button></div></div><div class=ajax__remove><button class=ajaxcart__product__remove type=button data-line=1 data-product-remove="">הסר</button></div></div></div></div></div><div><textarea class=input--full id=CartSpecialInstructions name=note placeholder="הערות מיוחדות לחנות"rows=4></textarea></div></div><div class=ajaxcart__footer><div class=ajaxcart__footer-row><h4 class="price price--label">סך הכל</h4><div class="price price--amount text-right"><h4 class=price>194.70 ₪</h4></div></div><small class=light-gray>משלוח חינם בקנייה מעל 80 ש"ח</small><div class=cart__row--buttons><div class=cart__buttons data-cart-buttons=""><fieldset class=cart__buttons__fieldset data-cart-buttons-fieldset=""><a class="btn btn--full drawer__button cart__btn"href=/cart>צפה בעגלה</a> <button class="btn btn--full btn--secondary drawer__button cart__checkout"type=submit name=checkout>המשך לתשלום</button></fieldset></div></div></div></form>` 
        var cartEmptyDesign = '<p class="cartEmpty">' + theme.strings.cart_empty + '</p>';
      	if($('.cartEmpty').length > 0) cartEmptyDesign = "";
        $('#CartContainer').append(cartDesign + cartEmptyDesign);
      	$('.cart__message').addClass('is-hidden')
      	$('.ajaxcart').hide();
    }else{    
      if(cart.note) $('#CartSpecialInstructions').val(cart.note);
      renderCart(cart);
      $('.cartEmpty').hide();
    }
  });
}

function renderCart(cart) {
  
  $('.ajaxcart').show();
  appendData = "";
  var cartNote = "";
  if(cart.note) cartNote = cart.note;
  var cartNotes = `<div>
				<textarea name="note" class="input--full" placeholder="הערות מיוחדות לחנות" rows="4" id="CartSpecialInstructions">${cartNote}</textarea>
			</div>`
  for(var i = 0; i < cart.items.length; i++) {
      var getProductUrl = cart.items[i].url;
      var getFeaturedImage = cart.items[i].featured_image.url;
      var getProductTitle = cart.items[i].title;
      var getProductQuantity = cart.items[i].quantity; 
      var getVariantTitle = cart.items[i].variant_title || ""; 
      var getprice = slate.Currency.formatMoney(cart.items[i].line_price, theme.moneyFormat); 
      var getProductId = cart.items[i].id; 
      var cartTotlaPrice = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
      var dataLine = (i+1);
      appendData = appendData +  `<div class="ajaxcart__product">
<div class="ajaxcart__row" data-line="${dataLine}">
        <div class="ajaxcart__product__image">
          <a href="${getProductUrl}" class="ajaxcart__product__image-bg lazyloaded" data-bgset="${getFeaturedImage}" data-parent-fit="contain" style="background-image: url("${getFeaturedImage}");">
            <picture>
              <source data-srcset="${getFeaturedImage}" sizes="56px" srcset="${getFeaturedImage}">
              <img alt="" class="lazyautosizes lazyloaded" data-sizes="auto" sizes="56px">
            </picture>
          </a>						
        </div>
        <div class="ajaxcart__product__info">
          <p>
            <a href="${getProductUrl}" class="ajaxcart__product__title">${getProductTitle}
            </a>
            <span class="ajaxcart__product__meta">${getVariantTitle}
            </span>
            <span class="ajaxcart__product__price">
              ${getprice}
            </span>
          </p>
          <div class="ajax__row">                          
            <div class="ajax__qty___wrapper">
              <div class="qty js-qty">
                <button type="button" class="qty__adjust qty__adjust--minus js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="${getProductId}" data-qty="${getProductQuantity}" data-line="${dataLine}">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 14 14">
                    <path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z">
                    </path>
                  </svg>
                  <span class="fallback-text">−
                  </span>
                </button>
                <input type="number" name="updates[]" class="qty__input js-qty__input" value="${getProductQuantity}" min="0" data-id="${getProductId}" data-line="${dataLine}" aria-label="quantity" pattern="[0-9]*">
                <button type="button" class="qty__adjust qty__adjust--plus js-qty__adjust js-qty__adjust--plus icon-fallback-text" data-id="${getProductId}" data-line="${dataLine}" data-qty="${getProductQuantity}">
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 14 14">
                    <path d="M7 0a.75.75 0 01.75.75v12.5a.75.75 0 11-1.5 0V.75A.75.75 0 017 0z">
                    </path>
                    <path d="M14 7a.75.75 0 01-.75.75H.75a.75.75 0 110-1.5h12.5A.75.75 0 0114 7z">
                    </path>
                  </svg>
                  <span class="fallback-text">+
                  </span>
                </button>
              </div>
            </div>
            <div class="ajax__remove">
              <button type="button" class="ajaxcart__product__remove" data-product-remove="" data-line="${dataLine}">
                הסר
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>`;
    
  }
  $('.ajaxcart__inner').html('');
  $('.ajaxcart__inner').html(appendData + cartNotes);
  $('.price--amount h4').html(cartTotlaPrice);
  cartProgress(cart.total_price)
  setTimeout(function(){
    addQuantityUpdate();
    if($('.js-drawer-open-cart').eq(0).attr('aria-expanded') == "false") {
      $('.js-drawer-open-cart').eq(0).trigger('click');
    }    
    if(bindclickEvent) removeCartProduct();  
  },200);
  $('.cart__btn').on('click',function(){
  	updateCartNote()
  })
}

function updateCartNote() {
 var notes = {
    note: $('#CartSpecialInstructions').val()
  }
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', notes);
  
}

function cartProgress(carTotalPrice) {
  var getDataLimit = parseInt($('.cart__message').attr('data-limit')); 
  var totalPrice = (carTotalPrice/100);
  var percentage = ((totalPrice/getDataLimit)*100);
  var remainingPrice = (getDataLimit - totalPrice)*100;
  $('[data-free-shipping-amount=""]').html( slate.Currency.formatMoney(remainingPrice, theme.moneyFormat));
  $('.cart__message').removeClass('is-hidden');
  if(totalPrice < getDataLimit ){    
    $('.cart__message__default').removeClass('is-hidden');
    $('.cart__message').removeClass('is-success');
    $('.cart__message__progress').removeClass('cart__message__progress--hidden');
    $('.cart__message__progress').val(percentage);
  }else{
    $('.cart__message').addClass('is-success');
    $('.cart__message__default').addClass('is-hidden')
    $('.cart__message__progress').addClass('cart__message__progress--hidden')
  }
}
function removeCartProduct() {
  $('.ajaxcart__product__remove').off('click').on('click',function () {
    var $el = $(this);
    var line = ($el.data('line'));
    $('.ajaxcart').addClass('is-loading');
    $.ajax({
      url:'cart/change.js',
      data:{
        'line': line,
        'quantity': 0
      },
      dataType:'json',
      type:'post',
      contentType: 'application/x-www-form-urlencoded',
      success:function(response){
        $('.ajaxcart').removeClass('is-loading');
        fetchCart();    
      },
    }); 
  });
}

function desktopSliderClick() {
 	galleryTopIndex = galleryTop.activeIndex; 
  	var getIndex = galleryTopIndex % $('.sliderProductTitles ul li').length;
  	$('.sliderProductTitles ul li').eq(getIndex).children('a').trigger('click')
}


$(document).on("click", ".variants-wrapper [data-add-to-cart]", function () {
  if ($(this).parents('form').find('.date-and-time-input-row input').length > 0) {
    $("#custom-popup")
    .css("display", "flex")  // force flex
    .hide()                  // hide immediately
    .fadeIn(300, function () {
      hideCart();            // call after fadeIn finishes
    })
    .addClass("show");

  }
});

$(document).on("click", '.product-grid-item [type="submit"]', function () {
  if ($(this).parents('.product-grid-item').find('.date-and-time-input').length > 0) {
    $("#custom-popup")
    .css("display", "flex")  // force flex
    .hide()                  // hide immediately
    .fadeIn(300, function () {
      hideCart();            // call after fadeIn finishes
    })
    .addClass("show");

  }
});

$(document).on("click", '.featured_collection-button [type="submit"]', function () {
  if ($(this).parents('.featured_collection-button').find('.date-and-time-input').length > 0) {
    $("#custom-popup")
    .css("display", "flex")  // force flex
    .hide()                  // hide immediately
    .fadeIn(300, function () {
      hideCart();            // call after fadeIn finishes
    })
    .addClass("show");

  }
});


// Close popup (button)
$(document).on("click", ".custom-close-btn, .ok-custom-close-btn", function () {
  $("#custom-popup").fadeOut(300, function () {
    $(this).removeClass("show");
    showCart()
  });
});

// Close popup (outside click)
$(document).on("click", function (e) {
  if ($(e.target).is("#custom-popup")) {
    $("#custom-popup").fadeOut(300, function () {
      $(this).removeClass("show");
      showCart()
    });
  }
});


function showCart(){
  document.querySelector('body').classList.remove('hide-drawer');

  const cartDrawer = document.querySelector('#CartDrawer');

  if (cartDrawer) {
    document.querySelector('body').classList.add('js-drawer-open-right')
    document.querySelector('body').classList.add('js-drawer-open')
    cartDrawer.setAttribute('tabindex', '-1');
    cartDrawer.setAttribute('data-scroll-lock-scrollable', '');
  }
}

function hideCart(){
  document.querySelector('body').classList.add('hide-drawer');
}



$(document).on("click", ".custom-aod_buy_button", function () {

  let form = $(this).parents('form')[0];
  let formData = new FormData(form);

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    fetch('/cart/add', {
        method: 'POST',
        body: formData
    }).then(function (response) {
        if (response.ok) {
            location.href='/checkout';
            return response.json();
        }
        throw response;
    }).then(function (data) {
        console.log(data);
    }).catch(function (error) {
        console.warn(error);
    });
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
  
});



document.addEventListener("DOMContentLoaded", function() {
  var popup = document.getElementById("inventory-popup");
  if (!popup) return;

  popup.querySelectorAll("[data-popup-close]").forEach(function(btn) {
    btn.addEventListener("click", function() {
      popup.classList.remove("active");
    });
  });

  popup.querySelector(".inventory-popup__overlay").addEventListener("click", function() {
    popup.classList.remove("active");
  });
});